import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mobile-loop",
  "use": "mobile-loop-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"mobile-loop\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-2-3h25v25H-2z\" /><g transform=\"translate(1 1)\"><circle stroke=\"#9F9F9F\" stroke-width=\"2\" cx=\"6.473\" cy=\"6.473\" r=\"6.473\" /><path fill=\"#9F9F9F\" d=\"M10 12.121L12.121 10l5.778 5.778-2.12 2.121z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol